import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Button, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import { BALANCE_RECORD_TYPE_MAP } from "src/config/constants";
import { asyncRequest } from "src/services/network";
import UserInfo from "src/components/common/UserInfo";

const TABLE_HEAD = [{ id: "id", label: "ID", alignRight: false }, { id: "nickname", label: "用户", alignRight: false }, { id: "amount", label: "金额", alignRight: false }, { id: "current", label: "当前股数", alignRight: false }, { id: "type", label: "类型", alignRight: false }, { id: "detail", label: "详情", alignRight: false }, { id: "remark", label: "备注", alignRight: false }, { id: "createdAt", label: "创建时间", alignRight: false }, { id: "操作" }];

const moreMenus = [
  // { title: "编辑", icon: iconEdit2 }
];

export default function SharesRecord() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/finance/share/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`/user/detail/${row.uid}`);
    }
  };

  const emptyRows = filter.size - items.length;
  const isUserNotFound = items.length === 0;

  return (
    <Page title="股数明细">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            股数明细
          </Typography>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, user, realname, amount, current, createdAt, remark, type, detail } = row;
                    const isItemSelected = selected.indexOf(realname) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox">
                        <TableCell align="left">{id}</TableCell>
                        <TableCell component="th" scope="row">
                          <UserInfo {...user} />
                        </TableCell>
                        <TableCell align="left">{StringUtil.trimZero(amount)}</TableCell>
                        <TableCell align="left">{StringUtil.trimZero(current)}</TableCell>
                        <TableCell align="left"> {['报单', '系统增加', '系统减少'][type]}</TableCell>
                        <TableCell align="left">{detail}</TableCell>
                        <TableCell align="left">{remark}</TableCell>
                        {/* <TableCell>
                          <Label variant="ghost" color={["warning", "error", "success", "warning"][status]}>
                            {BALANCE_RECORD_TYPE_MAP[type]}
                          </Label>
                        </TableCell> */}
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="right">
                          <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  );
}
